import React, { useState, useRef, useEffect } from 'react';

interface ConceptsDropdownProps {
  selectedConcepts: string[];
  setSelectedConcepts: (concepts: string[]) => void;
  disabled: boolean;
  is_study_participant: boolean | null;
}

const allConcepts = ["Variables", "Strings", "Lists", "Dictionaries", "Selection Statements (if/else,etc.)", "Loops", "Arithmetic Operators"];

const ConceptsDropdown: React.FC<ConceptsDropdownProps> = ({
  selectedConcepts,
  setSelectedConcepts,
  disabled,
  is_study_participant
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredConcepts, setFilteredConcepts] = useState(allConcepts);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const isDisabled = disabled && (is_study_participant ?? false);

  useEffect(() => {
    const filtered = allConcepts.filter(concept => 
      concept.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredConcepts(filtered);
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleConcept = (concept: string) => {
    if (isDisabled) return;
    if (selectedConcepts.includes(concept)) {
      setSelectedConcepts(selectedConcepts.filter(c => c !== concept));
    } else if (selectedConcepts.length < 5) {
      setSelectedConcepts([...selectedConcepts, concept]);
    }
  };

  const toggleAllConcepts = () => {
    if (isDisabled) return;
    if (selectedConcepts.length === allConcepts.length) {
      setSelectedConcepts([]);
    } else {
      setSelectedConcepts(allConcepts.slice(0, 5));
    }
  };

  return (
    <div className="input-group inline-group">
      <div className="concepts-dropdown" ref={dropdownRef}>
        <h2>Programming Concepts</h2>
        <div className="dropdown-container">
          <input
            type="text"
            placeholder="Add 1-5 programming concepts"
            value={searchTerm}
            onChange={(e) => !isDisabled && setSearchTerm(e.target.value)}
            onFocus={() => !isDisabled && setIsOpen(true)}
            className="search-input"
            disabled={isDisabled || undefined}
          />
          {isOpen && (
            <div className="dropdown-list">
              {/* <label> */}
                {/* <input
                  type="checkbox"
                  checked={selectedConcepts.length === allConcepts.length}
                  onChange={toggleAllConcepts}
                /> */}
                {/* All Concepts ({allConcepts.length}) */}
              {/* </label> */}
              {filteredConcepts.map((concept) => (
                <label key={concept}>
                  <input
                    type="checkbox"
                    checked={selectedConcepts.includes(concept)}
                    onChange={() => toggleConcept(concept)}
                    disabled={isDisabled || (!selectedConcepts.includes(concept) && selectedConcepts.length >= 5)}
                  />
                  {concept}
                </label>
              ))}
            </div>
          )}
        </div>
        <div className="selected-concepts">
          {selectedConcepts.map(concept => (
            <span key={concept} className="concept-tag">
              {concept}
              <button onClick={() => toggleConcept(concept)} disabled={isDisabled || undefined}>×</button>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConceptsDropdown;